import React, { useEffect, useState } from 'react';
import Wizard from '@/components/atoms/Wizard';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Text } from '@/components/atoms/Text';
import RawModal from '@/components/atoms/RawModal';
import { computeText } from '@/locales/utils';
import { useDeleteMenuByIdMutation } from '@/services/innovorder/menu/menu.endpoints';
import { getUserToken } from '@/redux/user';
import { StepContainer } from './DeleteMenuModal.style';

export type DeleteMenuModalProps = {
    menuId: number | null;
    menuName: string | null;
    onHide: () => void;
};

export const DeleteMenuModal: React.FunctionComponent<React.PropsWithChildren<DeleteMenuModalProps>> = ({
    onHide,
    menuId,
    menuName = '',
}) => {
    const intl = useIntl();
    const token = useSelector(getUserToken);
    const [deleteMenuById, { isSuccess: isDeleteSuccess, isLoading: isDeleteLoading }] = useDeleteMenuByIdMutation();
    const [name, setName] = useState(menuName);

    useEffect(() => {
        setName(name);
    }, [name, setName]);

    useEffect(() => {
        if (isDeleteSuccess) {
            onHide();
        }
    }, [isDeleteSuccess, onHide]);

    return (
        <RawModal isOpen={true} onHide={onHide}>
            <Wizard
                width={480}
                steps={[
                    {
                        title: 'menu.modal.delete.title',
                        onCancel: onHide,
                        component: (
                            <StepContainer>
                                <Text
                                    type="normal"
                                    weight="regular"
                                    text={computeText(intl, 'menu.modal.delete.description', {
                                        menuName: menuName ?? '',
                                    })}
                                />
                            </StepContainer>
                        ),
                    },
                ]}
                isLoading={isDeleteLoading}
                onValidate={() => {
                    if (menuId) {
                        deleteMenuById({ menuId, token });
                    }
                }}
            />
        </RawModal>
    );
};
